import * as React from 'react'
import { connect } from 'react-redux'


/*

Simply provides the entire configuration to the wrapped component

*/


const mapStateToProps = (state, initialProps) => ({
    ...initialProps,
    config: state.config
})


export function withConfig (Wrapped:React.ComponentClass){

    return connect(mapStateToProps)(class extends React.Component{

        render(){
            return <Wrapped { ...this.props } />
        }

    })

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/config/index.tsx